import { GoodgameSignal } from "./GoodgameSignal";

/**
 *    NumberSignal
 *
 *     @author Alexander
 */

export class NumberSignal extends GoodgameSignal {
    constructor() {
        super(Number);
    }

    public signal(num: number): void {
        super.dispatch(num);
    }
}
